export default __webpack_public_path__ + "images/referenzen/imagefilm/seiko_imagefilm.mp4";